import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { generateKioskQr } from 'api/Kiosk';

export const useKioskQr = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();
  return useQuery(['kioskQr', ...dependencies], () => generateKioskQr(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    enabled: !!params.practiceId,
    ...options
  });
};
